import { Card, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import FormAction from "../../../../components/common/FormAction";

function EmergencyContact({data}) {
  const [checked, setChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const status = {
        "emergencyContact.name": values.name,
        "emergencyContact.address": values.address,
        "emergencyContact.phoneNumber": values.phoneNumber,
        "emergencyContact.emailAddress": values.email,
        "emergencyContact.relationship": values.relationship,
    };
    try {
      const tenantRef = doc(
        db,
        "companies",
        companyName,
        "tenants",
        data?.id
      );
      updateDoc(tenantRef, status);
      setChecked(false);
      toast.success("Emergency contact updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    name: data?.emergencyContact?.name,
    address: data?.emergencyContact?.address,
    phoneNumber: data?.emergencyContact?.phoneNumber,
    email: data?.emergencyContact?.email,
    relationship: data?.emergencyContact?.relationship,
  };
  return (
    <Card
      title="Emergency Contact"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
          initialValues={initialValues}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Name" name="name">
            <Input />
          </Form.Item>
          <Form.Item label="Address" name="address">
            <Input />
          </Form.Item>
          <Form.Item label="Phone Number" name="phoneNumber">
            <Input />
          </Form.Item>
          <Form.Item label="Email Address" name="email">
            <Input />
          </Form.Item>
          <Form.Item label="Relationship" name="relationship">
            <Input />
          </Form.Item>
          <FormAction submit="submit" cancel={onCancel} />
        </Form>
      ) : null}
    </Card>
  );
}

export default EmergencyContact;
